import { navItems, siteMeta, topicWall } from '@/mocks/homeData';

export default function SiteFooter() {
  return (
    <footer className="w-full bg-secondary-950 text-background-50">
      {/* 厚运营壳：三段式 */}
      <div className="mx-auto max-w-[1440px] px-4 md:px-8">
        <div className="grid grid-cols-1 gap-8 border-b border-background-50/15 py-10 sm:grid-cols-2 lg:grid-cols-12 lg:gap-6 lg:py-12">
          {/* 品牌 */}
          <div className="lg:col-span-4">
            <div className="flex items-center gap-3">
              <div className="flex h-11 w-11 items-center justify-center rounded-md bg-primary-500">
                <i className="ri-flashlight-fill text-2xl text-background-50" aria-hidden="true"></i>
              </div>
              <div>
                <p className="font-heading text-xl font-black">{siteMeta.name}</p>
                <p className="font-label text-[11px] tracking-[0.2em] text-background-50/50">{siteMeta.slogan}</p>
              </div>
            </div>
            <p className="mt-4 max-w-sm font-body text-sm leading-relaxed text-background-50/65">
              {siteMeta.intro}
              我们汇总的是公开讨论中的观点与态度，不代表认同其中任何一种立场。
            </p>
            <div className="mt-5 flex items-center gap-3">
              {['ri-wechat-line', 'ri-weibo-line', 'ri-rss-line'].map((icon) => (
                <span
                  key={icon}
                  className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-md border border-background-50/20 text-background-50/70 transition-colors hover:border-accent-400 hover:text-accent-300"
                >
                  <i className={`${icon} text-lg`} aria-hidden="true"></i>
                </span>
              ))}
            </div>
          </div>

          {/* 栏目导航 */}
          <div className="lg:col-span-2">
            <h4 className="font-heading text-sm font-bold tracking-wider text-background-50">栏目</h4>
            <ul className="mt-4 flex flex-col gap-2.5">
              {navItems.map((item) => (
                <li key={item.href}>
                  <a
                    href={item.href}
                    className="cursor-pointer font-label text-sm text-background-50/60 transition-colors hover:text-accent-300"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* 热门话题 */}
          <div className="lg:col-span-3">
            <h4 className="font-heading text-sm font-bold tracking-wider text-background-50">热门话题</h4>
            <ul className="mt-4 flex flex-wrap gap-2">
              {topicWall.slice(0, 8).map((topic) => (
                <li key={topic.id}>
                  <a
                    href="#hot-wall"
                    className="block cursor-pointer rounded-full border border-background-50/20 px-3 py-1 font-label text-xs text-background-50/70 transition-colors hover:border-accent-400 hover:text-accent-300"
                  >
                    {topic.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* 声明 */}
          <div className="lg:col-span-3">
            <h4 className="font-heading text-sm font-bold tracking-wider text-background-50">内容说明</h4>
            <ul className="mt-4 flex flex-col gap-2.5 font-label text-xs leading-relaxed text-background-50/60">
              <li className="flex items-start gap-2">
                <i className="ri-shield-check-line mt-0.5 text-accent-400" aria-hidden="true"></i>
                内容为公开讨论的汇总与转述，仅供参考
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-error-warning-line mt-0.5 text-accent-400" aria-hidden="true"></i>
                不鼓励人身攻击，请理性表达观点
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-mail-send-line mt-0.5 text-accent-400" aria-hidden="true"></i>
                内容异议可通过订阅栏联系我们
              </li>
            </ul>
          </div>
        </div>

        {/* 版权条 */}
        <div className="flex flex-col items-start justify-between gap-2 py-5 sm:flex-row sm:items-center">
          <p className="font-label text-[11px] text-background-50/45">
            © 2026 {siteMeta.name} · 舆情观察与观点汇总 · 本页为静态演示页面
          </p>
          <p className="font-label text-[11px] text-background-50/45">
            数据统计口径：公开讨论量 · 更新频率：每小时
          </p>
        </div>
      </div>
    </footer>
  );
}